// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageCard_card__ZCeks {
  border-radius: 8px;
  margin: 17px 10px;
  border: 1px solid #e6e6e6;
  height: -moz-fit-content;
  height: fit-content;
}
.ImageCard_card__ZCeks .ImageCard_cardImage__MYjGy {
  border-radius: 8px 8px 0px 0px;
  width: 100%;
  border-bottom: 1px solid #e6e6e6;
  background-color: #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ImageCard_card__ZCeks .ImageCard_cardInfo__HelAF {
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 20px;
  border-radius: 0px 0px 8px 8px;
  height: 54px;
}

.ImageCard_small__rygRh {
  width: 90%;
  max-width: 418px;
  min-width: 350px;
  box-shadow: 0px 4px 4px rgba(153, 153, 153, 0.15);
}
.ImageCard_small__rygRh .ImageCard_cardImage__MYjGy {
  height: 176.25px;
}
.ImageCard_small__rygRh .ImageCard_cardInfo__HelAF {
  height: 45.32px;
}

.ImageCard_medium__TAsqy {
  width: 290px;
  box-shadow: 0px 4px 4px rgba(153, 153, 153, 0.15);
}
.ImageCard_medium__TAsqy .ImageCard_cardImage__MYjGy {
  height: 290px;
}
.ImageCard_medium__TAsqy .ImageCard_cardInfo__HelAF {
  height: 54px;
}

.ImageCard_large__vO3ar {
  width: 90%;
  max-width: 417px;
  min-width: 350px;
}
.ImageCard_large__vO3ar .ImageCard_cardImage__MYjGy {
  height: 432px;
}
.ImageCard_large__vO3ar .ImageCard_cardInfo__HelAF {
  height: 32px;
}
.ImageCard_large__vO3ar .ImageCard_cardName__y31YC {
  width: 50%;
}
.ImageCard_large__vO3ar .ImageCard_secondaryInfo__0dNe3 {
  color: #054ab0;
  font-weight: bold;
  width: 50%;
  text-align: right;
}

.ImageCard_loading__\\+uAUj .ImageCard_cardImage__MYjGy {
  background: linear-gradient(127deg, #ffffff, rgb(219, 214, 214));
  background-size: 400% 400%;
  animation: ImageCard_gradient__FSYQ5 4s ease infinite;
}
.ImageCard_loading__\\+uAUj .ImageCard_cardName__y31YC {
  background: linear-gradient(-45deg, #ffffff, rgb(219, 214, 214));
  background-size: 400% 400%;
  animation: ImageCard_gradient__FSYQ5 4s ease infinite;
  height: 20px;
  width: 70px;
}
@keyframes ImageCard_gradient__FSYQ5 {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/ImageCard/ImageCard.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,wBAAA;EAAA,mBAAA;AAFF;AAIE;EACE,8BAAA;EACA,WAAA;EACA,gCAAA;EACA,yBCFkB;EDGlB,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,eElBK;EFmBL,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;AAHJ;;AAOA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,iDAAA;AAJF;AAME;EACE,gBAAA;AAJJ;AAOE;EACE,eAAA;AALJ;;AASA;EACE,YAAA;EACA,iDAAA;AANF;AAQE;EACE,aAAA;AANJ;AASE;EACE,YAAA;AAPJ;;AAWA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;AARF;AAUE;EACE,aAAA;AARJ;AAWE;EACE,YAAA;AATJ;AAYE;EACE,UAAA;AAVJ;AAaE;EACE,cC1EK;ED2EL,iBEtEG;EFuEH,UAAA;EACA,iBAAA;AAXJ;;AAgBE;EACE,gEAAA;EACA,0BAAA;EACA,qDAAA;AAbJ;AAgBE;EACE,gEAAA;EACA,0BAAA;EACA,qDAAA;EACA,YAAA;EACA,WAAA;AAdJ;AAiBE;EACE;IACE,2BAAA;EAfJ;EAkBE;IACE,6BAAA;EAhBJ;EAmBE;IACE,2BAAA;EAjBJ;AACF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.card {\n  border-radius: 8px;\n  margin: 17px 10px;\n  border: 1px solid #e6e6e6;\n  height: fit-content;\n\n  .cardImage {\n    border-radius: 8px 8px 0px 0px;\n    width: 100%;\n    border-bottom: 1px solid #e6e6e6;\n    background-color: colors.$color-background-02;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .cardInfo {\n    font-size: typography.$body-l;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 16px 20px;\n    border-radius: 0px 0px 8px 8px;\n    height: 54px;\n  }\n}\n\n.small {\n  width: 90%;\n  max-width: 418px;\n  min-width: 350px;\n  box-shadow: 0px 4px 4px rgba(153, 153, 153, 0.15);\n\n  .cardImage {\n    height: 176.25px;\n  }\n\n  .cardInfo {\n    height: 45.32px;\n  }\n}\n\n.medium {\n  width: 290px;\n  box-shadow: 0px 4px 4px rgba(153, 153, 153, 0.15);\n\n  .cardImage {\n    height: 290px;\n  }\n\n  .cardInfo {\n    height: 54px;\n  }\n}\n\n.large {\n  width: 90%;\n  max-width: 417px;\n  min-width: 350px;\n\n  .cardImage {\n    height: 432px;\n  }\n\n  .cardInfo {\n    height: 32px;\n  }\n\n  .cardName {\n    width: 50%;\n  }\n\n  .secondaryInfo {\n    color: colors.$accent;\n    font-weight: typography.$bold;\n    width: 50%;\n    text-align: right;\n  }\n}\n\n.loading {\n  .cardImage {\n    background: linear-gradient(127deg, #ffffff, rgb(219, 214, 214));\n    background-size: 400% 400%;\n    animation: gradient 4s ease infinite;\n  }\n\n  .cardName {\n    background: linear-gradient(-45deg, #ffffff, rgb(219, 214, 214));\n    background-size: 400% 400%;\n    animation: gradient 4s ease infinite;\n    height: 20px;\n    width: 70px;\n  }\n\n  @keyframes gradient {\n    0% {\n      background-position: 0% 50%;\n    }\n\n    50% {\n      background-position: 100% 50%;\n    }\n\n    100% {\n      background-position: 0% 50%;\n    }\n  }\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `ImageCard_card__ZCeks`,
	"cardImage": `ImageCard_cardImage__MYjGy`,
	"cardInfo": `ImageCard_cardInfo__HelAF`,
	"small": `ImageCard_small__rygRh`,
	"medium": `ImageCard_medium__TAsqy`,
	"large": `ImageCard_large__vO3ar`,
	"cardName": `ImageCard_cardName__y31YC`,
	"secondaryInfo": `ImageCard_secondaryInfo__0dNe3`,
	"loading": `ImageCard_loading__+uAUj`,
	"gradient": `ImageCard_gradient__FSYQ5`
};
export default ___CSS_LOADER_EXPORT___;
